import { orchestrator } from 'satcheljs';
import { updateShouldShowTasks } from '../actions/publicActions';
import { getLoadedDateRange } from '../selectors/listEventsCalendarCacheSelectors';
import { getTodoCache } from '../store/todoCache';
import { TodoDescriptorType } from 'owa-todo-cache';

export const updateShouldShowTasksOrchestrator = orchestrator(
    updateShouldShowTasks,
    actionMessage => {
        const { shouldShowTasks, scenarioId } = actionMessage;
        const existingRange = getLoadedDateRange(scenarioId);

        if (shouldShowTasks) {
            getTodoCache(scenarioId).fetchTasks({
                type: TodoDescriptorType.DueDate,
                startDate: existingRange.start,
                endDate: existingRange.end,
            });
            getTodoCache(scenarioId).subscribeNotifications();
        } else {
            getTodoCache(scenarioId).releaseLock();
        }
    }
);
